// The rating prompts, the Trustpilot box (RatingTrustpilot, opened by App.vue)
// and the OSAT/CSAT card in Bytesförslag (SatisfactionSurveyCard), keep out
// of the way while the member finishes their ad or pays (Filip, 2026-10-26):
// not on the payment, subscription, boost and Superintresse pages (routes with
// `meta.purchase`), and not while one of these is open.

// Global modals (ui/showGlobalModal): "Gör klart din annons", the
// Superintresse purchase sheet and paywall, and the boost modal with its
// re-boost offer.
const PAUSING_GLOBAL_MODALS = [
  'CompleteListingModal',
  'SuperInterestPurchase',
  'SuperInterestPaywall',
  'BoostInfo'
];

// boostPanelOpen: the boost purchase panel (extraVisibility/isVisible).
export function ratingPromptsPaused({ route, globalModal, boostPanelOpen }) {
  return Boolean(
    boostPanelOpen ||
      PAUSING_GLOBAL_MODALS.includes(globalModal) ||
      (route && route.meta && route.meta.purchase)
  );
}
